/**
 * An object containing events for about modal events
 */
var AboutModalEvent = /** @class */ (function () {
    function AboutModalEvent() {
    }
    return AboutModalEvent;
}());
export { AboutModalEvent };
//# sourceMappingURL=about-modal-event.js.map